import React from "react";
import PropTypes from 'prop-types'
import makeStyles from "@material-ui/core/styles/makeStyles";
import DataTable from "../DataTable";

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        padding: 10
    }
}));

const Validations = ({validations, inheritedValidations, onChangeItem, onChangeAll}) => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <DataTable
                onChangeAll={onChangeAll}
                onChangeItem={onChangeItem}
                disabled={!Boolean(validations.length)}
                data={validations.length ? validations : inheritedValidations}
                title={'Validations'}
                basePath={'recordValidations'}
            />
        </div>
    )
};
export default Validations

Validations.propTypes = {
    validations: PropTypes.array,
    onChangeItem: PropTypes.func,
    onChangeAll: PropTypes.func
};